import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import type { MoneyPageLink } from "@/data/money-pages/types";
import { RocSignalLabel } from "@/components/roc/RocSignalLabel";

interface MoneyPageLinksProps {
  title: string;
  subtitle: string;
  links: MoneyPageLink[];
  language?: 'es' | 'en';
}

/**
 * ROC KNOWLEDGE GRAPH — mapa editorial de conexiones.
 * Página actual → servicio relacionado → recurso de la Search Library.
 * Enlaces semánticos reales, siempre crawlables.
 */
export const MoneyPageLinks = ({ title, subtitle, links, language = 'es' }: MoneyPageLinksProps) => {
  if (!links.length) return null;

  return (
    <section className="border-b border-slate-800 bg-slate-950 py-16 lg:py-24">
      <div className="container-custom">
        <RocSignalLabel index="08" tone="invert">
          {language === 'es' ? 'Conexiones' : 'Connections'}
        </RocSignalLabel>
        <div className="mt-5 grid gap-6 lg:grid-cols-[1fr_420px] lg:items-end">
          <h2 className="font-display max-w-2xl text-2xl font-bold leading-tight text-white lg:text-4xl">{title}</h2>
          <p className="text-sm leading-relaxed text-slate-400">{subtitle}</p>
        </div>

        <ul className="mt-12 border-t border-slate-800">
          {links.map((link, index) => (
            <li key={link.to + link.label} className="border-b border-slate-800">
              <Link
                to={link.to}
                className="group grid grid-cols-[52px_1fr] items-start gap-4 py-6 transition-colors hover:bg-slate-900/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand md:grid-cols-[52px_1fr_1fr_28px]"
              >
                <span className="font-mono text-[11px] text-brand">{String(index + 1).padStart(2, '0')}</span>
                <span className="text-base font-semibold text-white group-hover:text-brand">{link.label}</span>
                <span className="col-start-2 text-sm leading-relaxed text-slate-400 md:col-start-3">
                  {link.description}
                </span>
                <ArrowRight
                  className="roc-cta-arrow hidden h-4 w-4 self-center text-brand md:block"
                  aria-hidden="true"
                />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
